/* tslint:disable */
/* eslint-disable */
/**
 * Maestro API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Parameters for a choice. For example, the user may choice the database system which can be MySql or Oracle.
 * @export
 * @interface Choice
 */
export interface Choice {
    /**
     * The identifier of the choice.
     * @type {string}
     * @memberof Choice
     */
    id: string;
    /**
     * A displayable name of the choice
     * @type {string}
     * @memberof Choice
     */
    name: string;
    /**
     * Service ids to choose from.
     * @type {Array<Service>}
     * @memberof Choice
     */
    services: Array<Service>;
}
/**
 *
 * @export
 * @interface Deployment
 */
export interface Deployment {
    /**
     * 
     * @type {string}
     * @memberof Deployment
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Deployment
     */
    owner?: string;
    /**
     * 
     * @type {string}
     * @memberof Deployment
     */
    expirationDate?: string;
    /**
     * 
     * @type {Resources}
     * @memberof Deployment
     */
    resources?: Resources;
    /**
     * 
     * @type {DeploymentStatus}
     * @memberof Deployment
     */
    status?: DeploymentStatus;
    /**
     * 
     * @type {Array<ServiceInfo>}
     * @memberof Deployment
     */
    serviceInfos?: Array<ServiceInfo>;
}
/**
 * Contains all parameters for a single deployment.
 * @export
 * @interface DeploymentParameters
 */
export interface DeploymentParameters {
    /**
     * The name of the deployment which is also used as part of the subdomain.
     * @type {string}
     * @memberof DeploymentParameters
     */
    name: string;
    /**
     * Expiration time in days
     * @type {number}
     * @memberof DeploymentParameters
     */
    expiry?: number;
    /**
     * Parameters for each service which is started for this deployment.
     * @type {Array<ProductParameters>}
     * @memberof DeploymentParameters
     */
    products?: Array<ProductParameters>;
}
/**
 * The status of the deployment or a single service.
 * @export
 * @enum {string}
 */
export enum DeploymentStatus {
    Started = 'started',
    Available = 'available',
    Failed = 'failed',
    Unknown = 'unknown'
}

/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    message: string;
}
/**
 * Custom input
 * @export
 * @interface Parameter
 */
export interface Parameter {
    /**
     * The type of the input
     * @type {string}
     * @memberof Parameter
     */
    inputType: string;
    /**
     * The identifier of the input.
     * @type {string}
     * @memberof Parameter
     */
    id: string;
    /**
     * The name of the input which is displayed to the user.
     * @type {string}
     * @memberof Parameter
     */
    name: string;
    /**
     * Optional values for the input the user can choose from.
     * @type {Array<string>}
     * @memberof Parameter
     */
    values?: Array<string>;
    /**
     * Value which is set as default.
     * @type {string}
     * @memberof Parameter
     */
    defaultValue?: string;
    /**
     * Set to true if the parameter is required
     * @type {boolean}
     * @memberof Parameter
     */
    required?: boolean;
}
/**
 * Value of a parameter
 * @export
 * @interface ParameterValue
 */
export interface ParameterValue {
    /**
     * Identifier for the parameter
     * @type {string}
     * @memberof ParameterValue
     */
    id: string;
    /**
     * The value of the parameter
     * @type {string}
     * @memberof ParameterValue
     */
    value: string;
}
/**
 * Description of a product. A service can be a mail service, Knowledge, Helpline, etc.
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * Identifier of the service.
     * @type {string}
     * @memberof Product
     */
    id: string;
    /**
     * The displayable name of the service.
     * @type {string}
     * @memberof Product
     */
    name: string;
    /**
     * Docker image tags the user can choose from.
     * @type {Array<string>}
     * @memberof Product
     */
    imageTags: Array<string>;
    /**
     * Services the user can optional choose from.
     * @type {Array<Service>}
     * @memberof Product
     */
    services: Array<Service>;
    /**
     * Services the user must choose from.
     * @type {Array<Choice>}
     * @memberof Product
     */
    choice: Array<Choice>;
    /**
     * Input components for custom parameters
     * @type {Array<Parameter>}
     * @memberof Product
     */
    parameters?: Array<Parameter>;
}
/**
 * Startparameters for a single service within the deployment.
 * @export
 * @interface ProductParameters
 */
export interface ProductParameters {
    /**
     * The id of the service.
     * @type {string}
     * @memberof ProductParameters
     */
    id: string;
    /**
     * The docker image tag.
     * @type {string}
     * @memberof ProductParameters
     */
    imageTag: string;
    /**
     * Services which should be started with the service.
     * @type {Array<ServiceParameters>}
     * @memberof ProductParameters
     */
    services?: Array<ServiceParameters>;
    /**
     * Additional input parameters
     * @type {Array<ParameterValue>}
     * @memberof ProductParameters
     */
    parameters?: Array<ParameterValue>;
}
/**
 * 
 * @export
 * @interface Resources
 */
export interface Resources {
    /**
     * 
     * @type {number}
     * @memberof Resources
     */
    memoryMBUsed: number;
    /**
     * 
     * @type {number}
     * @memberof Resources
     */
    memoryMBLimit: number;
}
/**
 * Definition of a service.
 * @export
 * @interface Service
 */
export interface Service {
    /**
     * Identifier of the service.
     * @type {string}
     * @memberof Service
     */
    id: string;
    /**
     * The displayable name of the service.
     * @type {string}
     * @memberof Service
     */
    name: string;
    /**
     * True if the service is optional
     * @type {boolean}
     * @memberof Service
     */
    optional: boolean;
    /**
     * Docker image tags the user can choose from.
     * @type {Array<string>}
     * @memberof Service
     */
    imageTags: Array<string>;
}
/**
 * 
 * @export
 * @interface ServiceInfo
 */
export interface ServiceInfo {
    /**
     * 
     * @type {string}
     * @memberof ServiceInfo
     */
    name?: string;
    /**
     * 
     * @type {DeploymentStatus}
     * @memberof ServiceInfo
     */
    status?: DeploymentStatus;
    /**
     * 
     * @type {string}
     * @memberof ServiceInfo
     */
    url?: string;
}
/**
 * Startparameters for a service.
 * @export
 * @interface ServiceParameters
 */
export interface ServiceParameters {
    /**
     * The id of the service.
     * @type {string}
     * @memberof ServiceParameters
     */
    id: string;
    /**
     * The docker image tag.
     * @type {string}
     * @memberof ServiceParameters
     */
    imageTag?: string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    field?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidationError
     */
    messages?: Array<string>;
}

/**
 * ApiApi - axios parameter creator
 * @export
 */
export const ApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the client config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOidcConfig: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/oidc-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken("oauth2", [])
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiApi - functional programming interface
 * @export
 */
export const ApiApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the client config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOidcConfig(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ApiApiAxiosParamCreator(configuration).getOidcConfig(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ApiApi - factory interface
 * @export
 */
export const ApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns the client config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOidcConfig(options?: any): AxiosPromise<void> {
            return ApiApiFp(configuration).getOidcConfig(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiApi - object-oriented interface
 * @export
 * @class ApiApi
 * @extends {BaseAPI}
 */
export class ApiApi extends BaseAPI {
    /**
     * 
     * @summary Returns the client config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOidcConfig(options?: any) {
        return ApiApiFp(this.configuration).getOidcConfig(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DeploymentApi - axios parameter creator
 * @export
 */
export const DeploymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the resources used by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResources: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/deployments/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken("oauth2", [])
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all deployments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeployments: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/deployments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken("oauth2", [])
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Starts a new deployment
         * @param {DeploymentParameters} deploymentParameters Parameters for starting the deployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startDeployment: async (deploymentParameters: DeploymentParameters, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deploymentParameters' is not null or undefined
            if (deploymentParameters === null || deploymentParameters === undefined) {
                throw new RequiredError('deploymentParameters','Required parameter deploymentParameters was null or undefined when calling startDeployment.');
            }
            const localVarPath = `/deployments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken("oauth2", [])
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deploymentParameters !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deploymentParameters !== undefined ? deploymentParameters : {}) : (deploymentParameters || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stop a deployment
         * @param {string} name name of a deployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopDeployment: async (name: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling stopDeployment.');
            }
            const localVarPath = `/deployments/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken("oauth2", [])
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeploymentApi - functional programming interface
 * @export
 */
export const DeploymentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the resources used by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResources(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resources>> {
            const localVarAxiosArgs = await DeploymentApiAxiosParamCreator(configuration).getResources(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary List all deployments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDeployments(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Deployment>>> {
            const localVarAxiosArgs = await DeploymentApiAxiosParamCreator(configuration).listDeployments(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Starts a new deployment
         * @param {DeploymentParameters} deploymentParameters Parameters for starting the deployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startDeployment(deploymentParameters: DeploymentParameters, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await DeploymentApiAxiosParamCreator(configuration).startDeployment(deploymentParameters, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Stop a deployment
         * @param {string} name name of a deployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopDeployment(name: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await DeploymentApiAxiosParamCreator(configuration).stopDeployment(name, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DeploymentApi - factory interface
 * @export
 */
export const DeploymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns the resources used by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResources(options?: any): AxiosPromise<Resources> {
            return DeploymentApiFp(configuration).getResources(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all deployments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeployments(options?: any): AxiosPromise<Array<Deployment>> {
            return DeploymentApiFp(configuration).listDeployments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Starts a new deployment
         * @param {DeploymentParameters} deploymentParameters Parameters for starting the deployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startDeployment(deploymentParameters: DeploymentParameters, options?: any): AxiosPromise<void> {
            return DeploymentApiFp(configuration).startDeployment(deploymentParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stop a deployment
         * @param {string} name name of a deployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopDeployment(name: string, options?: any): AxiosPromise<string> {
            return DeploymentApiFp(configuration).stopDeployment(name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeploymentApi - object-oriented interface
 * @export
 * @class DeploymentApi
 * @extends {BaseAPI}
 */
export class DeploymentApi extends BaseAPI {
    /**
     * 
     * @summary Returns the resources used by the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentApi
     */
    public getResources(options?: any) {
        return DeploymentApiFp(this.configuration).getResources(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all deployments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentApi
     */
    public listDeployments(options?: any) {
        return DeploymentApiFp(this.configuration).listDeployments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Starts a new deployment
     * @param {DeploymentParameters} deploymentParameters Parameters for starting the deployment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentApi
     */
    public startDeployment(deploymentParameters: DeploymentParameters, options?: any) {
        return DeploymentApiFp(this.configuration).startDeployment(deploymentParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stop a deployment
     * @param {string} name name of a deployment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentApi
     */
    public stopDeployment(name: string, options?: any) {
        return DeploymentApiFp(this.configuration).stopDeployment(name, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken("oauth2", [])
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProducts(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Product>>> {
            const localVarAxiosArgs = await ProductApiAxiosParamCreator(configuration).listProducts(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary List all products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts(options?: any): AxiosPromise<Array<Product>> {
            return ProductApiFp(configuration).listProducts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     * 
     * @summary List all products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public listProducts(options?: any) {
        return ProductApiFp(this.configuration).listProducts(options).then((request) => request(this.axios, this.basePath));
    }
}


